module.exports = __webpack_public_path__ + "i18n/ru.233ac8dba4fe5e9d947b342c7a8e8c00.json";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=i18n/[name].[hash].[ext]!./i18n/ru.json
// module id = 855
// module chunks = 60